import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import { ExpandableCardContextProvider, useExpandableCardContext } from './expandableCardContext';
import { useExpandableGridContext } from './expandableGridContext';

type ExpandableCardProps = {
  className?: string;
};

export const ExpandableCard: React.FC<
  PropsWithChildren<ExpandableCardProps & { id: string; gridPosition?: number }>
> = ({ id, gridPosition, ...rest }) => {
  return (
    <ExpandableCardContextProvider id={id} gridPosition={gridPosition}>
      <CardContent {...rest} />
    </ExpandableCardContextProvider>
  );
};

const CardContent: React.FC<PropsWithChildren<ExpandableCardProps>> = ({ children, className }) => {
  const { expanded, showContent, gridPosition } = useExpandableCardContext();
  const { getCardHeight, getGridColumn, getGridRow } = useExpandableGridContext();

  return (
    <div
      className={classNames(className)}
      style={{
        gridRow: getGridRow(expanded, gridPosition),
        gridColumn: getGridColumn(expanded),
        height: getCardHeight(expanded),
      }}
    >
      <div className={classNames('h-full', { 'opacity-0': !showContent })}>{children}</div>
    </div>
  );
};
